import type { ReactNode } from 'react';

export interface FieldCardProps {
  label: string;
  children: ReactNode;
  badge?: ReactNode;
  active?: boolean;
  hint?: string;
  tone?: 'default' | 'muted';
}

export function FieldCard({
  label,
  children,
  badge,
  active = false,
  hint,
  tone = 'default',
}: FieldCardProps) {
  return (
    <section
      className={[
        'rounded-[12px] px-4 py-3.5 transition-shadow',

        active
          ? 'bg-[var(--color-amber-100)]/25 shadow-[0_0_0_1.5px_var(--color-amber-500)]'
          : 'bg-white shadow-[0_1px_2px_rgb(22_18_26/0.04),0_6px_16px_-12px_rgb(22_18_26/0.16)]',
      ].join(' ')}
    >
      <div className="mb-2 flex items-center gap-2">
        <span
          className={[
            'h-1.5 w-1.5 shrink-0 rounded-full',
            tone === 'muted' ? 'bg-ink-300' : 'bg-plum-700',
          ].join(' ')}
          aria-hidden="true"
        />
        <h3 className="text-[13px] font-bold tracking-[-0.005em] text-ink-900">
          {label}
        </h3>
        {badge ? <span className="ml-auto">{badge}</span> : null}
      </div>
      {hint ? <p className="mb-1.5 text-[11.5px] text-ink-500">{hint}</p> : null}
      {children}
    </section>
  );
}
